import { render } from "./CardPromReport.vue?vue&type=template&id=12afa2cc&scoped=true"
import script from "./CardPromReport.vue?vue&type=script&lang=js"
export * from "./CardPromReport.vue?vue&type=script&lang=js"

import "./CardPromReport.vue?vue&type=style&index=0&id=12afa2cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12afa2cc"]])

export default __exports__